function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7437 16.5178C16.3766 16.5178 9.33317 12.5237 9.33317 12.5237V11.9C9.33317 11.1272 9.96037 10.5 10.7346 10.5H24.7528C25.5277 10.5 26.1549 11.1272 26.1549 11.9L26.1437 12.6C26.1437 12.6 19.1766 16.5178 17.7437 16.5178ZM17.7435 18.4428C19.2422 18.4428 26.1435 14.7 26.1435 14.7L26.1547 23.1C26.1547 23.8728 25.5275 24.5 24.7526 24.5H10.7344C9.96091 24.5 9.33301 23.8728 9.33301 23.1L9.34421 14.7C9.34351 14.7 16.3764 18.4428 17.7435 18.4428Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 13.1267,
  y1: 1.4595,
  x2: 4.37675,
  y2: 21.875,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#37AEE2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1E96C8"
})));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mail.ce29d23e.svg";
export { ForwardRef as ReactComponent };